import { env } from '@/env'
import { api } from '@/services/fintalk/api'

import type { Bot } from '../company-bots/list-by-company'

export async function listProjectBots(
  companyId: string,
  projectId: string,
): Promise<Bot[]> {
  const resp = await api.get<Bot[]>(
    env.VITE_FINTALK_BACKOFFICE_URL,
    `/company/${companyId}/project/${projectId}/bots`,
  )

  return resp.body
}
